import { render } from "./PlayersComponent.vue?vue&type=template&id=5010684a&scoped=true"
import script from "./PlayersComponent.vue?vue&type=script&lang=js"
export * from "./PlayersComponent.vue?vue&type=script&lang=js"

import "./PlayersComponent.vue?vue&type=style&index=0&id=5010684a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Shavin\\Documents\\apps\\10-candles\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5010684a"]])

export default __exports__